import moment from "moment";

export const formatFechaCorta = (fecha) => {
  if (!fecha) return "-";
  return moment(fecha, "YYYY-MM-DD").format("DD/MM/YYYY");
};

export const formatFechaHora = (fecha) => {
  if (!fecha) return "-";
  return moment(fecha).format("DD/MM/YYYY HH:mm");
};
